import { render, staticRenderFns } from "./RestorePassword.vue?vue&type=template&id=570a623e&scoped=true"
import script from "./RestorePassword.vue?vue&type=script&lang=js"
export * from "./RestorePassword.vue?vue&type=script&lang=js"
import style0 from "./RestorePassword.vue?vue&type=style&index=0&id=570a623e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570a623e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('570a623e')) {
      api.createRecord('570a623e', component.options)
    } else {
      api.reload('570a623e', component.options)
    }
    module.hot.accept("./RestorePassword.vue?vue&type=template&id=570a623e&scoped=true", function () {
      api.rerender('570a623e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/RestorePassword.vue"
export default component.exports